import namespace from '@rdfjs/namespace';
const builder = namespace('https://barnard59.zazuko.com/vocab#');
export const strict = builder;
export const loose = builder;
